import { OrderStatusConfig } from '../types';
import { OrderStatus, ServiceMethod } from '../types/order';

export const getOrderStatusConfig = (
  serviceMethod: string,
): OrderStatusConfig => {
  const isCollectionPointOrder =
    serviceMethod === ServiceMethod.COLLECTION_POINT;

  return {
    [OrderStatus.ASSIGNED]: {
      text: 'Up Next',
      buttonText: 'Order Picked',
      nextOrderStatus: OrderStatus.PICKED,
      order: 1,
      backgroundColor: '#FFFAEB',
      textColor: '#B54708',
      badgeColor: '#F79009',
    },
    [OrderStatus.PREPARED]: {
      text: 'Up Next',
      buttonText: 'Order Picked',
      nextOrderStatus: OrderStatus.PICKED,
      order: 1,
      backgroundColor: '#FFFAEB',
      textColor: '#B54708',
      badgeColor: '#F79009',
    },
    [OrderStatus.ASSIGNED_BUT_PREPARING]: {
      text: 'Up Next',
      buttonText: 'Order Picked',
      nextOrderStatus: OrderStatus.PICKED,
      order: 1,
      backgroundColor: '#FFFAEB',
      textColor: '#B54708',
      badgeColor: '#F79009',
    },
    [OrderStatus.PICKED]: {
      text: 'Delivering',
      buttonText: isCollectionPointOrder ? 'At Collection Point' : 'Complete',
      nextOrderStatus: isCollectionPointOrder
        ? OrderStatus.AT_COLLECTION_POINT
        : OrderStatus.COMPLETE,
      order: 2,
      backgroundColor: '#ECFDF3',
      textColor: '#027A48',
      badgeColor: '#12B76A',
      confirmCheck: isCollectionPointOrder ? false : true,
    },
    [OrderStatus.AT_COLLECTION_POINT]: {
      text: 'Waiting for Patron',
      buttonText: 'Complete',
      nextOrderStatus: OrderStatus.COMPLETE,
      order: 2,
      backgroundColor: '#ECFDF3',
      textColor: '#027A48',
      badgeColor: '#12B76A',
      confirmCheck: true,
    },
    [OrderStatus.REFUNDED]: {
      text: 'Delivering',
      buttonText: 'Complete',
      nextOrderStatus: OrderStatus.DELIVERED_BUT_REFUNDED,
      order: 2,
      backgroundColor: '#ECFDF3',
      textColor: '#027A48',
      badgeColor: '#12B76A',
      confirmCheck: isCollectionPointOrder ? false : true,
    },
  };
};

export const PASSWORD_POLICY_MESSAGES = {
  MIN_LENGTH: (value: number) => `a minimum length of ${value} characters`,
  REQUIRE_UPPERCASE: 'at least one uppercase letter',
  REQUIRE_LOWERCASE: 'at least one lowercase letter',
  REQUIRE_NUMBERS: 'at least one number',
  REQUIRE_SYMBOLS: 'at least one special character',
};

export const PASSWORD_POLICY_PREFIX = 'Password must contain';
